module.exports = __webpack_public_path__ + "static/media/view doc.cf3d4e0c.svg";